import React, { useEffect, useRef, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { processSurveyAnswers } from "../insight/index";
const Findings = () => {

  const themeMode = useSelector((state) => state.themeMode);
  const chartRef = useRef(null);
  const topMenuTabs = useSelector((state) => state.topMenuTabs);
  const leftMenuVisibility = topMenuTabs.tabs.find(
    (tab) => tab.id === topMenuTabs.activeTab
  ).states.leftMenuVisibility;
  const currentSurveyInsightData = useMemo(() => {
    const activeTab = topMenuTabs.tabs.find(
      (tab) => tab.id === topMenuTabs.activeTab
    );
    return activeTab ? activeTab.states.currentSurveyInsightData : null;
  }, [topMenuTabs.tabs, topMenuTabs.activeTab]);
  const [totalAnswers, setTotalAnswers] = useState([]);

  const groupedFindings =
    currentSurveyInsightData?.report_detail?.findings?.reduce((acc, item) => {
      if (!acc[item.section_name]) {
        acc[item.section_name] = [];
      }
      acc[item.section_name].push(item);
      return acc;
    }, {});

  const contentRef = useRef(null);
  const headerRef = useRef(null);
  const tableHeaderRef = useRef(null);
  const [scrolling, setScrolling] = useState(false);

  const handleScroll = () => {
    if (contentRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = contentRef.current;
      const isAtBottom = scrollTop + clientHeight >= scrollHeight - 5; // Tolerans payı
      setScrolling(isAtBottom);
    }
  };

  useEffect(() => {
    const survey_answers =
      currentSurveyInsightData?.report_detail?.survey_answers;
    if (survey_answers) {
      const processedAnswers = processSurveyAnswers(survey_answers);
      if (JSON.stringify(processedAnswers) !== JSON.stringify(totalAnswers)) {
        setTotalAnswers(processedAnswers);
        console.log("Processed Answers:", processedAnswers);
      }
      // setTotalAnswers(processedAnswers);

      console.log("Processed Answers:", processedAnswers);
    }
  }, [currentSurveyInsightData]);
  const nodesData = [
    { label: "Node 1", x: 50, y: 50 },
    { label: "Node 2", x: 200, y: 50 },
    { label: "Node 3", x: 50, y: 150 },
  ];

  const edgesData = [
    { sourceX: 50, sourceY: 50, targetX: 200, targetY: 50 },
    { sourceX: 50, sourceY: 50, targetX: 50, targetY: 150 },
  ];
  return (
    <div
      className={`flex flex-col w-full pl-4 ${themeMode === "dark"
        ? "bg-[#1a1a28] text-white"
        : "bg-[#fbfbfc] text-black"
        }`}
    >
      <div className=" px-4 sm:px-12 w-full flex min-h-screen flex-col">
        <h1
          className={`w-full  sticky top-0 z-0 inline-flex flex-wrap items-center text-center   md:text-left break-words text-[20px] sm:text-[26px] md:text-[30px] lg:text-[34px] font-bold   my-4 ${themeMode === "dark" ? "text-[#44a5e4]" : "text-[#44a5e4]"
            }`} ref={headerRef}
        >
          KEY FINDINGS AND OBSERVATIONS
        </h1>
        <div className=" min-w-full lg:min-w-0  overflow-x-auto  ">
          <div className="inline-block min-w-full">
            <div className="relative">
              <div
                className={`flex flex-row lg:grid lg:grid-cols-5 min-w-full lg:min-w-0 sticky top-0 z-0  ${themeMode === "dark" ? "bg-[#44a5e4]" : "bg-[#44a5e4]"
                  } text-white text-xs md:text-md font-bold`} ref={tableHeaderRef}
              >
                {[
                  "SECTION",
                  "KEY FINDINGS",
                  "DESCRIPTION",
                  "HURDLES TO OVERCOME",
                  "IMPLICATIONS",
                ].map((title, index) => (
                  <div key={index} className={`p-4  min-w-[100vw] md:min-w-[20vw] md:max-w-[20vw] lg:max-w-full lg:min-w-full whitespace-normal break-words  ${themeMode === "dark" ? "bg-[#44a5e4]" : "bg-[#44a5e4]"
                    } `}>
                    {title}
                  </div>
                ))}
              </div>
              <div
                className="border border-gray-300"
                ref={contentRef}
                onScroll={handleScroll}
              >
                {Object.entries(groupedFindings).map(([section, items],sectionIndex) =>{
                  const isLastSection = sectionIndex === Object.keys(groupedFindings).length - 1;
                  const lastItemIndex = items.length - 1;
                
                  return items.map((item, index) => (
                    <div
                      key={index}
                      className={`${index} flex flex-row lg:grid lg:grid-cols-5 divide-x  ${ isLastSection && index === lastItemIndex
                        ? "":"border-[#44a5e4] border-b border-dashed"}  divide-[#44a5e4] divide-dashed`}
                    >
                      <div
                        className={`p-4  min-w-[100vw] md:min-w-[20vw] md:max-w-[20vw] lg:max-w-full lg:min-w-full whitespace-normal break-words  flex items-center ${themeMode === "dark" ? "text-white" : "text-black"
                          }`}
                      >
                        {item.section_name}
                      </div>
                      <div className={`p-4 flex items-center min-w-[100vw] md:min-w-[20vw] md:max-w-[20vw] lg:max-w-full  lg:min-w-full whitespace-normal break-words  ${themeMode === "dark" ? "text-white" : "text-black"
                        }`}>
                        {item.finding}
                      </div>
                      <div
                        className={`p-4 flex items-center min-w-[100vw] md:min-w-[20vw] md:max-w-[20vw] lg:max-w-full  lg:min-w-full whitespace-normal break-words  ${themeMode === "dark" ? "text-white" : "text-black"
                          }`}
                      >
                        {item.finding_detail}
                      </div>
                      <div
                        className={`p-4 flex items-center min-w-[100vw] md:min-w-[20vw] md:max-w-[20vw] lg:max-w-full  lg:min-w-full whitespace-normal break-words ${themeMode === "dark" ? "text-white" : "text-black"
                          }`}
                      >
                        {item.finding_hurdles_to_overcome}
                      </div>
                      <div
                        className={`p-4 flex items-center  min-w-[100vw] md:min-w-[20vw] md:max-w-[20vw] lg:max-w-full lg:min-w-full whitespace-normal break-words ${themeMode === "dark" ? "text-white" : "text-black"
                          }`}
                      >
                        {item.finding_implications}
                      </div>
                    </div>
                  ))
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Findings;
